import StringMethods from '~/utils/character'

export type HospitalPayload = Partial<{
	location: string
	address: string
	name: string
	search: string
	id: string
	[id: string]: string | number
}>
/**
 * @prop  { location: string;   address?: string;  name?: string; search?: string;  }
 * */
export const getHospitalList = async (query?: HospitalPayload) => {
	const { data } = await useAPI<IRequestResponse<PaginationContext<HospitalListResponse>>>(`/hospitals/list`, {
		query
	})

	return data.value
}

export const getStatesApi = async () => {
	const { toCapitalize } = StringMethods()
	const { data } = await useAPI<IRequestResponse<{ states: LocalLgaStateContext[] }>>(`/states-with-lga`, {
		...useApiCache()
	})
	let result: any = []
	if (Array.isArray(data.value?.data.states)) {
		result = data.value.data.states.map(item => ({
			label: toCapitalize(item.state ?? ''),
			value: (item.state as string) || ''
		}))
	}
	return result
}
export const getHospitalLocationById = async (product_id: string) => {
	const { toCapitalize } = StringMethods()
	const { data } = await useAPI<IRequestResponse<{ states: LocalLgaStateContext[] }>>(
		`/hospitals/products/${product_id}/locations
`,
		{
			...useApiCache()
		}
	)
	let result: any = []
	return result
}
